@let titleErrorKey = titleError();
<div class="app-settings">
  <andor-settings-shell [title]="'App Settings' | translate">
    <div class="sections">
      <section class="settings-section" aria-labelledby="app-settings-instance">
        <h4 id="app-settings-instance">{{ 'Instance' | translate }}</h4>
        <div class="identity-fields">
          <div>
            <andor-text-input
              [control]="appTitle"
              [label]="'App name' | translate"
              [toolTipMsg]="'Shown in the browser tab and in bookmarks.' | translate"
              [errorMsg]="titleErrorKey ? (titleErrorKey | translate) : ''"
              placeholder="Rooms" />
            @if (titleErrorKey) {
              <p class="field-error" role="alert">{{ titleErrorKey | translate }}</p>
            }
          </div>
          <andor-region-select
            [host]="gateway()"
            (hostChange)="selectRegion($event)"
            [allowUnlisted]="true"
            [disabled]="saving()"
            [hint]="
              'Changes apply to new connections. People in a call stay on the current region until they rejoin.'
                | translate
            " />
        </div>
      </section>
      <andor-theme-editor
        class="settings-section"
        role="region"
        aria-labelledby="app-settings-appearance"
        [disabled]="saving()">
        <h4 editor-heading id="app-settings-appearance">{{ 'Appearance' | translate }}</h4>
      </andor-theme-editor>
    </div>
    <div #actions actions class="actions">
      @let message = error();
      @if (message) {
        <div class="error" role="alert">
          <span class="error__text">
            {{ 'Saving app settings failed: [message]' | translate: { message } }}
          </span>
          <andor-icon-btn
            class="error__close"
            [tooltip]="'Close' | translate"
            (click)="dismissError()">
            <fa-icon [icon]="faXmark"></fa-icon>
          </andor-icon-btn>
        </div>
      }
      @let changed = appConfigStore.hasConfigChanged();
      <div class="buttons">
        <andor-button (click)="save()" [disabled]="!changed || saving() || !!titleErrorKey">
          {{ 'Save' | translate }}
        </andor-button>
        <andor-button (click)="cancel()" [disabled]="!changed || saving()">
          {{ 'Cancel' | translate }}
        </andor-button>
      </div>
    </div>
  </andor-settings-shell>
</div>
